module.exports = __webpack_public_path__ + "static/img/platform-icon-4.e5325f8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/download/platform-icon-4.png
// module id = pSHC
// module chunks = 0